let sale_page_types = {
  SALE_PAGE_INSTANCE_TYPE: 'instance',
  SALE_PAGE_PROTOTYPE_TYPE: 'prototype'
};
let pre_sell_page_types = {
  PRE_SELL_PAGE_INSTANCE_TYPE: 'instance',
  PRE_SELL_PAGE_PROTOTYPE_TYPE: 'prototype'
};
let offer_tracking_types = {
  OFFER_TRACKING_SALE_PAGE: 'sale-page',
  OFFER_TRACKING_PRE_SELL_PAGE: 'pre-sell-page'
};
let product_feed_types = {
  GOOGLE_FEED: 'google-feed',
  FACEBOOK_FEED: 'facebook-feed'
};
let languages = [{
  emoji: '🇺🇸',
  text: 'English',
  short: 'En',
  value: 'en',
  rtl: false
}, {
  emoji: '🇲🇦',
  text: 'العربية',
  short: 'Ar',
  value: 'ar',
  rtl: true
}];
let SVG_IMAGE_NAMES = {
  GREAT_SERVICE_SVG_NAME: 'great-service',
  GREAT_CLIENT_SERVICE_SVG_NAME: 'great-client-service',
  ABOUT_US_SVG_NAME: 'about-us',
  FREE_DELIVER_SVG_NAME: 'free-delivery',
  TRUSTED_SITE_SVG_NAME: 'trusted-site',
  SECURED_PAYMENT_SVG_NAME: 'secured-payment',
  FAST_SUPPORT_SVG_NAME: 'fast-support',
  RETURN_GUARANTEE_SVG_NAME: 'return-guarantee',
  E_COMMERCE_SVG_NAME: 'e-commerce'
};
export { SVG_IMAGE_NAMES, product_feed_types, offer_tracking_types, pre_sell_page_types, sale_page_types, languages };